import './soomsoompita/style';
import FormStructure from './soomsoompita/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js